import styled from 'styles/styled';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TitleModal = styled.h3`
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7A7E8C;
  font-weight: 600;
  margin: 0;
  text-align: center;
`;

export const TextModal = styled.p`
  font-size: 12px;
  text-align: center;
  margin: 0 0 6px;
  font-weight: 400;
  line-height: 1.4;
  color: #A7A8B2;
`;

export const Row = styled.div`
  background: #292B2E;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  position: relative;

  &.DarkInfo {
    background: transparent;
    border: 1px solid #2A2E34;
    padding: 8px 12px;

    > h6:first-child {
      color: #7A7E8C;
      font-size: 11px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      font-weight: 600;
    }
  }

  &.RowInput {
    padding: 0 12px;
    height: 44px;

    h6 {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      margin: 0;

      &.TextSpecial {
        left: 12px;
        font-size: 11px;
        color: #7A7E8C;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        font-weight: 600;
      }

      &.AmountSpecial {
        right: 12px;
        font-size: 12px;
        color: #A7A8B2;
        font-weight: 500;
      }
    }

    &:has(.TextSpecial:first-child) {
      .TextSpecial {
        color: #7A7E8C;
      }
    }
  }
`;

export const Text = styled.h6`
  font-size: 12px;
  font-weight: 500;
  color: #EFEFEF;
  margin: 0;
`;

export const Amount = styled.h6`
  font-size: 13px;
  font-weight: 700;
  color: #EFEFEF;
  margin: 0;
  font-variant-numeric: tabular-nums;
`;

export const InputText = styled.input`
  background: transparent;
  outline: none;
  border: 0;
  height: 100%;
  width: 100%;
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  color: #EFEFEF;
  font-variant-numeric: tabular-nums;
  font-family: inherit;
  padding: 0 50px 0 110px;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: #7A7E8C;
  }
`;

export const ErrorText = styled.div`
  color: #ff6b6b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  margin: -2px 2px 2px;
`;

export const ButtonModal = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;

  div {
    flex: 1;

    button {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 700;
      font-family: inherit;
      cursor: pointer;
      background: #292B2E;
      color: #EFEFEF;
      border: 0;
      transition: opacity 120ms;

      &:hover:not(:disabled) {
        opacity: 0.92;
      }
    }

    &:last-child {
      button {
        background: #52D381;
        color: #0A0A0A;
      }
    }
  }
`;

export const LoadButton = styled.div`
  button.buttonLoad {
    &:disabled {
      color: #A7A8B2;
      font-size: 12px;
      opacity: 0.7;
    }
  }
`;

export const LoadWrap = styled.div`
  display: inline-block;
  width: 14px;
  height: 14px;
  animation: rotation 800ms infinite linear;
  border-radius: 999px;
  box-shadow: 0.6px 0.5px 0 0.6px #52D381;
  margin-right: 6px;
  vertical-align: middle;
  @keyframes rotation {
    from { transform: rotate(0deg); }
    to { transform: rotate(359deg); }
  }
`;
